import { create_element } from './operations.js';

const policy =
	/*                                                                                                       */
	globalThis?.window?.trustedTypes &&
	/*           */ globalThis.window.trustedTypes.createPolicy('svelte-trusted-html', {
		/*                       */
		createHTML: (html) => {
			return html;
		}
	});

/*                       */
export function create_trusted_html(html) {
	return /*                 */ (policy?.createHTML(html) ?? html);
}

/**
 *
 */
export function create_fragment_from_html(html) {
	var elem = create_element('template');
	elem.innerHTML = create_trusted_html(html.replaceAll('<!>', '<!---->')); /*               */
	return elem.content;
}
